import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKey } from './config';

export const useInvalidateNotifications = () => {
	const queryClient = useQueryClient();

	return useCallback(() => {
		queryClient.invalidateQueries([queryKey]);
	}, [queryClient]);
};
